<mat-paginator
  [pageSizeOptions]="pageSizes"
  [pageSize]="currentPageSize"
  [showFirstLastButtons]="true"
  (page)="onPageEvent($event)"></mat-paginator>
